import React, { useState, useEffect } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import {
  GetProductDetailsService,
  CategoryService,
} from "../../services/services";
import { ProductDetails as Product } from "../../modals/Product";
import { findNestedObj, getPathTo } from "../../utils/common";
import { history } from "../../utils/appConfig";
import { MODULES } from "../../utils/routesNames";
import AddToCartForm from "../AddToCartForm";
import AskQuestion from "../AskQuestion";
import { isValidImageUrl } from "../../utils/common";
import Loader from "../Loader";
import { generalMessages as MSG } from "../../utils/constants";
import { NO_IMG } from "../../assets/images/images";
import SubstituteProducts from "../SubstituteProducts";
import ProductInformation from "./productInformation";

const ProductDetails = ({
  match: {
    params: { productID },
  },
}) => {
  const [product, setProduct] = useState<Product>();
  const [root, setRoot] = useState<any[]>([]);
  const [breadCrumbs, setBreadCrumbs] = useState([]);
  const [status, setStatus] = useState<string | null>(null);

  useEffect(() => {
    getCategories().then((res) => {
      getProductDetails(res);
    });
  }, []); // eslint-disable-line

  const getCategories = async () => {
    const result = await CategoryService();
    if (result.data.flag) {
      if (result.data.data.length !== 0) {
        return result.data.data;
      }
    } else {
      setStatus(MSG.ERROR_MSG);
    }
  };

  const getProductDetails = async (res: any) => {
    const decodedProductID = decodeURIComponent(productID);
    const result = await GetProductDetailsService(decodedProductID);
    if (result.data.flag && result.data.data) {
      setProduct(result.data.data);
      setStatus(null);
      setRoot(res);
      const item = findNestedObj(res, "id", result.data.data.category_id);
      const path = getPathTo(item ? item.name : "", res);
      setBreadCrumbs(path);
    } else {
      setStatus(MSG.PRODUCT_NOT_FOUND);
    }
  };

  const jumpToCategory = (name: string) => {
    const item = findNestedObj(root, "name", name);
    const path = getPathTo(item ? item.name : "", root);
    history.push(MODULES.allProducts.url, { item, path });
  };

  return (
    <div>
      <div className="product-wrapper">
        <section className="product-details">
          <div className="container-xl">
            <Breadcrumb className="primary-breadcrumb">
              {breadCrumbs &&
                breadCrumbs.map((item, index) => {
                  return index === 0 ? (
                    <Breadcrumb.Item
                      key={index}
                      onClick={() => history.push(MODULES.allProducts.url)}
                    >
                      {item}
                    </Breadcrumb.Item>
                  ) : (
                    <Breadcrumb.Item
                      key={index}
                      onClick={() => jumpToCategory(item)}
                    >
                      {item}
                    </Breadcrumb.Item>
                  );
                })}
              <Breadcrumb.Item active>
                <span className="text-truncate">{product?.name}</span>
              </Breadcrumb.Item>
            </Breadcrumb>

            {status ? (
              status
            ) : product ? (
              <div>
                <div className="row">
                  <div className="col-md-auto">
                    <div className="product-img">
                      <i>
                        <img
                          onError={() =>
                            setProduct({ ...product, product_image: NO_IMG })
                          }
                          src={
                            isValidImageUrl(product.product_image)
                              ? product.product_image
                              : NO_IMG
                          }
                          alt={product.product_image}
                        />
                      </i>
                    </div>
                  </div>
                  <div className="col-md">
                    <div className="product-micro-detail">
                      {product.product_model && (
                        <span className="product-model">
                          Product Code: {product.product_model}
                        </span>
                      )}
                      <h4 className="product-name">{product.name}</h4>
                      {product.allergen_images.length > 0 && (
                        <div className="d-flex align-items-center flex-wrap mb-3 gap-1">
                          {product.allergen_images.map((icon, index) => (
                            <img
                              key={index}
                              src={icon}
                              alt={`allergen-${index}`}
                              onError={(e) => (e.currentTarget.src = NO_IMG)}
                              className="img-fluid rounded mr-2"
                              style={{
                                width: "30px",
                                height: "30px",
                                objectFit: "contain",
                              }}
                            />
                          ))}
                        </div>
                      )}
                      <div className="d-flex">
                        <span className="price">
                          $ {product.price}{" "}
                          {(product.name.toLowerCase().startsWith("rw") ||
                            product.description
                              .toLowerCase()
                              .startsWith("rw")) &&
                            "/ 1 Kg"}
                        </span>
                        {product.rw_price && (
                          <span className="rw_price ml-4">
                            est. ${product.rw_price} Pack
                          </span>
                        )}
                      </div>
                      {product.out_of_stock ? (
                        <div className="out-of-stock">
                          {product.out_of_stock ? "OUT OF STOCK" : ""}
                          <SubstituteProducts id={product.id} />
                        </div>
                      ) : (
                        ""
                      )}
                      <AddToCartForm {...product} />
                      <AskQuestion {...product} />
                      {product.is_cut_off_time_completed && (
                        <p className="cutoff-time-message">
                          Today's order cutoff has passed, earliest delivery
                          time is the day after tomorrow
                        </p>
                      )}
                      <div className="product-description">
                        <h6>Product Brand</h6>
                        <p>{product.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
                {(product.product_information || product.template_values) && (
                  <div>
                    <ProductInformation
                      productInformation={product.product_information}
                      templateValues={product.template_values}
                    />
                  </div>
                )}
              </div>
            ) : (
              <Loader />
            )}
          </div>
        </section>
      </div>
    </div>
  );
};
export default ProductDetails;
